/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { graphql } from 'gatsby'
import _orderBy from 'lodash/orderBy'
import _size from 'lodash/size'
// Redux
import { loadFilter, setYear } from '~lib/saga/filter/actions'
// Containers
import Layout from '~2021/containers/Layout'
// Components
import { ItemContainer } from '~2021/components/ContainerCard'
import ContainerHeader from '~2021/components/ContainerHeader'
import Seo from '~2021/components/Seo'
// Utils

const filterSelector = (state) => state.filter

const FandomCategory = ({ data, location, pageContext, path }) => {
  const dispatch = useDispatch()
  const {
    allMarkdownRemark: { edges: items },
  } = data

  const { categoryId, categoryTitle, year: yearContextPage } = pageContext
  const {
    data: { id: filterId, year: filterYear },
  } = useSelector(filterSelector)

  if (categoryId !== filterId && _size(filterId) !== _size(categoryId)) {
    dispatch(loadFilter(categoryId))
  }

  if (yearContextPage !== filterYear) {
    dispatch(setYear(yearContextPage))
  }

  return (
    <Layout page="Home">
      <Seo title={categoryTitle} path={`/${filterYear}/location.pathname`} />
      <ContainerHeader />
      <ItemContainer items={items} location={location} />
    </Layout>
  )
}

export const query = graphql`
  query ($categoryId: [String], $year: [Int]) {
    allMarkdownRemark(
      filter: {
        fileAbsolutePath: { glob: "**/src/2021/data/fandoms/*.md" }
        frontmatter: { categories: { in: $categoryId }, year: { in: $year } }
      }
      sort: { fields: frontmatter___displayOrder, order: ASC }
      limit: 100
    ) {
      edges {
        node {
          id
          fields {
            fandomOfTheYear
            allEntertainment
            allSports
            allSuperlatives
            # brands
            celebrities
            college
            comics
            gaming
            mlb
            movies
            music
            nfl
            nhl
            other
            proBasketball
            soccer
            sportsFigures
            tv
            feature {
              html
              frontmatter {
                byLine
                dateCreated
                dateUpdated
                linkAttribution
                linkExternal
                nextToRank
                path
                title
                year
              }
            }
            hasFeature
          }
          frontmatter {
            categories
            categoryPrimary
            contentType
            fanBuzz
            imageCard
            imageDetail
            imageSocial
            path
            rank
            searchScore
            socialFollowing
            title
            twitterHandle
            year
            superlative
            displayOrder
          }
        }
      }
    }
  }
`
export default FandomCategory
